<template>
  <div>
    <el-dialog
      title="修改手机号"
      width="600px"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      custom-class="customW"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="200px" size="small" :rules="rules">
        <el-form-item
          label="当前手机号"
          label-width="100px"
          style="margin-bottom: 15px"
        >
        {{ userMobile }}
        </el-form-item>
        <el-form-item
          label="修改为"
          label-width="100px"
          prop="mobile"
          style="margin-bottom: 15px"
        >
          <el-input
            v-model="form.mobile"
            clearable
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close()" size="small">取 消</el-button>
        <el-button type="primary" @click="confirm('form')" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { editUserMobile } from '@/api/h5User.js'

export default {
  data() {
    var checkMobile = (rule, value, callback) => {
        if (value.trim() === '') {
          callback(new Error('请输入手机号码'));
        } else {
            let a=/^1\d{10}$/
            if (!a.test(value.trim())) {
                callback(new Error('请输入正确的手机号码'));
            } else {
                callback();
            }
        }
      };
    return {
      dialogFormVisible: false,
      userMobile:"",
      form: {
        mobile: "",
      },
      rules:{
        mobile: [
            { validator: checkMobile, trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    async isShow(row) {
      this.dialogFormVisible = true;
      this.userMobile = row.mobile
      this.form.userId = row.user_id
    },
    confirm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const {code} = await editUserMobile(this.form)
          if(code == 200){
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.close()
          }
        } else {
          return false;
        }
      });
    },
    close() {
      this.form = {
        mobile:""
      }
      this.$refs.form.resetFields();
      this.dialogFormVisible = false;
      this.$emit("ok")
    },
    handleClose(done) {
      done();
      this.close();
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .customW {
  border-radius: 10px !important;
  .el-dialog__header {
    border-bottom: 1px solid #e8eaec;
    .el-dialog__title {
      font-size: 14px;
      color: #17233d;
      font-weight: 700;
    }
  }
  .el-dialog__footer {
    border-top: 1px solid #e8eaec;
  }
}
</style>